import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../Base/Components/BaseModal/BaseModal';
import CaseChatPreview from './CaseChatPreview';
import { Size } from '../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	caseId: string;
}

const CaseChatPreviewModal: React.FC<Props> = props => {
	return (
		<BaseModal title='base.messagePreview' size={Size.SM} {...props}>
			<CaseChatPreview caseId={props.caseId} />
		</BaseModal>
	);
};

export default CaseChatPreviewModal;
